import React from 'react';

const Titles = () => (

        
            <div>
            <h1 className="title-container__title">Weather Spy App</h1>
            <p className="title-container__subtitle">Find out temperature, conditions and more</p>
            </div>
        
    
            );
export default Titles;